export default "__VITE_ASSET__9b9a89c6__"